import bem from 'utils/bem';

export const block = bem('episodes-step');
